module.exports = require("dyna-sync");